import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from '@core/services/profile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Profile } from '@shared/models/profile';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@core/services/alert.service';
import { CommonService } from '@core/services/common.service';

@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.scss'],
    standalone: false
})
export class PasswordChangeComponent implements OnInit, AfterViewInit, ModalInterface {

    @ViewChild('PasswordChange') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any, any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    form: FormGroup;
    formSms: FormGroup;
    private profile: Profile;

    private smsVerifiedSuccessfully: boolean = false;
    passwordVerifiedSuccessfully: boolean = false;

    private validationErrorTypes = ['minLength', 'upperCase', 'lowerCase', 'number', 'history'];
    public validationErrors = [];
    constructor(
        private commonService: CommonService,
        private dialogService: NxDialogService,
        private profileService: ProfileService,
        private translateService: TranslateService,
        private alertService: AlertService,
    ) {

        this.form = new FormGroup({
            currentPassword: new FormControl(null, Validators.required),
            newPassword: new FormControl(null, Validators.required),
            newRepeat: new FormControl(null, Validators.required)
        });

        this.formSms = new FormGroup({
            smsCode: new FormControl(null, Validators.required)
        });

        this.form.valueChanges.subscribe(() => {
            this.form.controls.currentPassword.setErrors(null);
            this.form.controls.newPassword.setErrors(null);
            this.form.controls.newRepeat.setErrors(null);
        });
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { showCloseIcon: true });
    }

    closeModal(): void {
        this.passwordVerifiedSuccessfully = false;
        this.modalDialogRef.close();
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    ngOnInit(): void {
    }

    inputData(inputData?: any): void {
        if (inputData['profile']) {
            this.profile = inputData['profile'];
        }
    }

    changePassword(event: SubmitEvent) {
        if (this.form.invalid) {
            return;
        }
        this.validationErrors = [];
        this.profileService.postUpdatePassword(
            this.form.controls.currentPassword.value,
            this.form.controls.newPassword.value,
            this.form.controls.newRepeat.value,
        ).subscribe({
            error: (errorResponse: HttpErrorResponse) => {

                let errors = {};
                const errorResponseErrors = Array.isArray(errorResponse.error)
                    ? errorResponse.error : [errorResponse.error];

                errorResponseErrors.forEach(error => {
                    errors[error['type']] = true;
                    if (error['data']) {
                        errors[error['type']] = error['data'];
                    }
                    if (this.form.get(error['type'])) {
                        this.form.get(error['type']).setErrors({});
                    }
                    this.validationErrorTypes.includes(error['type']) ?
                        (() => {
                            this.validationErrors.push(error['type']);
                            this.form.get('newPassword').setErrors({});
                        })() : null;
                });

                this.form.setErrors(errors);
                console.log(this.form)
            },
            next: (response) => {
                if (!this.smsVerifiedSuccessfully) {
                    this.profileService.generateSMSCode(this.profile.mobile, 'update_password').subscribe(
                        {
                            error: (errorResponse: HttpErrorResponse) => {
                                if(errorResponse.error['msg'] == 'attemptsExceeded'){
                                    this.translateService.get('error.sms.wait').subscribe( (trans) => {
                                        this.alertService.error(trans);
                                    })
                                }
                            },
                            next: (response) => {
                                const smsCode = response['pin'] ? response['pin'] : null
                                this.formSms.get('smsCode').setValue(smsCode);
                                this.passwordVerifiedSuccessfully = true;
                            }
                        });
                    return;
                }

                window.location.reload();
            },
        });
    }

    resend() {
        if (!this.profile.mobile) {
            this.translateService.get('error.service-call-fail').subscribe(trans => {
                this.alertService.error(trans);
            });
            return;
        }
        this.profileService.generateSMSCode(this.profile.mobile, 'update_profile_mobile').subscribe({
            error: (errorResponse: HttpErrorResponse) => {
                if(errorResponse.error['msg'] == 'attemptsExceeded'){
                    this.translateService.get('error.sms.wait').subscribe( (trans) => {
                        this.alertService.error(trans);
                    })
                }
            },
            next: (response) => {
                const smsCode = response['pin'] ? response['pin'] : null
                this.formSms.get('smsCode').setValue(smsCode);
            }
        });
    }

    checkSMSCode() {
        if (this.form.invalid) {
            return;
        }

        this.profileService.validateSMSCode(this.formSms.controls.smsCode.value, 'update_password').subscribe(() => {
            this.smsVerifiedSuccessfully = true;
            this.changePassword(new SubmitEvent('event'));
        });
    }

    isRed() {
        return this.commonService.env != 'prod' ? 'color-red': '';
    }
    
    getSuccessMessages(): Array<string> {

        if(!this.validationErrors.length){
            return [];
        }

        let successMessages = [];
        this.validationErrorTypes.forEach( type => {
            if(!this.validationErrors.includes(type)){
                successMessages.push(type);
            }
        })

        return successMessages;
    }
}
